<!-- Menu principal -->
<ng-template #colunasMenu let-coluna>
  @let config = coluna.config;
  <div cdkMenu class="mat-mdc-menu-panel mat-mdc-elevation-specific mat-elevation-z8">
    <div class="mat-mdc-menu-content">
      <!-- Ocultar -->
      @if (coluna.tipoColuna !== 'dadoAdicional') {
        <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="onToggleOcultarColuna(coluna, true)">
          <mat-icon svgIcon="mat:visibility_off"></mat-icon>
          <span class="mat-mdc-menu-item-text">Ocultar Coluna</span>
        </button>
      }

      <!-- Dados adicionais -->
      @if ((coluna.tipoColuna === 'criterio' || coluna.tipoColuna === 'simples') && coluna.dadosAdicionais.length > 0) {
        <button
          cdkMenuItem
          class="mat-mdc-menu-item"
          type="button"
          [cdkMenuTriggerFor]="dadosAdicionaisMenu"
          [cdkMenuTriggerData]="{ coluna }"
        >
          <mat-icon svgIcon="mat:playlist_add"></mat-icon>
          <span class="mat-mdc-menu-item-text">Dados Adicionais</span>
          <svg class="mat-mdc-menu-submenu-icon" viewBox="0 0 5 10" focusable="false" aria-hidden="true">
            <polygon points="0,0 5,5 0,10" />
          </svg>
        </button>
      }

      <!-- Ordenação -->
      @if (config.ordenacao != 'asc') {
        <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="ordenar(coluna, 'asc')">
          <mat-icon svgIcon="mat:arrow_upward"></mat-icon>
          <span class="mat-mdc-menu-item-text">Ordem Crescente</span>
        </button>
      } @else {
        <ng-container *ngTemplateOutlet="cancelarOrdenacao"></ng-container>
      }
      @if (config.ordenacao != 'desc') {
        <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="ordenar(coluna, 'desc')">
          <mat-icon svgIcon="mat:arrow_downward"></mat-icon>
          <span class="mat-mdc-menu-item-text">Ordem Decrescente</span>
        </button>
      } @else {
        <ng-container *ngTemplateOutlet="cancelarOrdenacao"></ng-container>
      }
      <ng-template #cancelarOrdenacao>
        <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="ordenar(coluna)">
          <mat-icon svgIcon="mat:cancel"></mat-icon>
          <span class="mat-mdc-menu-item-text">Cancelar Ordenação</span>
        </button>
      </ng-template>

      <!-- Subtotal -->
      @if (!ocultarSubtotal()) {
        @if (coluna.tipoDado === 'valor') {
          @if (!config.total) {
            <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="totalizar(coluna)">
              <mat-icon svgIcon="mat:functions"></mat-icon>
              <span class="mat-mdc-menu-item-text">Subtotal</span>
            </button>
          } @else {
            <ng-container *ngTemplateOutlet="cancelarSubtotal"></ng-container>
          }
          <ng-template #cancelarSubtotal>
            <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="totalizar(coluna)">
              <mat-icon svgIcon="mat:cancel"></mat-icon>
              <span class="mat-mdc-menu-item-text">Cancelar Subtotal</span>
            </button>
          </ng-template>
        }
      }

      <!-- Agrupar -->
      @if (!ocultarGrupo()) {
        @if (coluna.tipoColuna !== 'dadoAdicional' && coluna.tipoDado !== 'valor' && coluna.tipoDado !== 'data') {
          <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="agrupar(coluna)">
            <mat-icon svgIcon="mat:segment"></mat-icon>
            <span class="mat-mdc-menu-item-text">Agrupar</span>
          </button>
        }

        <!-- Agrupar data por mês -->
        @if (coluna.tipoColuna !== 'dadoAdicional' && coluna.tipoDado === 'data') {
          <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="agrupar(coluna)">
            <mat-icon svgIcon="mat:segment"></mat-icon>
            <span class="mat-mdc-menu-item-text">Agrupar Mês/Ano</span>
          </button>
        }
      }
    </div>
  </div>
</ng-template>

<!-- Menu grupo -->
<ng-template #gruposMenu let-grupo>
  @let coluna = grupo.coluna;
  <div cdkMenu class="mat-mdc-menu-panel mat-mdc-elevation-specific mat-elevation-z8">
    <div class="mat-mdc-menu-content">
      <!-- Dados adicionais -->
      @if ((coluna.tipoColuna === 'criterio' || coluna.tipoColuna === 'simples') && coluna.dadosAdicionais.length > 0) {
        <button
          cdkMenuItem
          class="mat-mdc-menu-item"
          type="button"
          [cdkMenuTriggerFor]="dadosAdicionaisMenu"
          [cdkMenuTriggerData]="{ coluna }"
        >
          <mat-icon svgIcon="mat:playlist_add"></mat-icon>
          <span class="mat-mdc-menu-item-text">Dados Adicionais</span>
          <svg class="mat-mdc-menu-submenu-icon" viewBox="0 0 5 10" focusable="false" aria-hidden="true">
            <polygon points="0,0 5,5 0,10" />
          </svg>
        </button>
      }

      <!-- Expandir grupo -->
      @if (!grupo.expandido) {
        <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="expandirRetrairGrupo(grupo, true)">
          <mat-icon svgIcon="mat:keyboard_double_arrow_down"></mat-icon>
          <span class="mat-mdc-menu-item-text">Expandir Nível</span>
        </button>
      }

      <!-- Retrair grupo -->
      @if (grupo.expandido) {
        <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="expandirRetrairGrupo(grupo, false)">
          <mat-icon svgIcon="mat:keyboard_double_arrow_up"></mat-icon>
          <span class="mat-mdc-menu-item-text">Retrair Nível</span>
        </button>
      }

      <!-- Remover grupo -->
      <button cdkMenuItem type="button" class="mat-mdc-menu-item" (click)="removerGrupo(coluna)">
        <mat-icon svgIcon="mat:cancel"></mat-icon>
        <span class="mat-mdc-menu-item-text">Remover Grupo</span>
      </button>
    </div>
  </div>
</ng-template>

<!-- Submenu dados adicionais -->
<ng-template #dadosAdicionaisMenu let-coluna="coluna" let-dadosAdicionais="coluna.dadosAdicionais">
  <div cdkMenu class="mat-mdc-menu-panel mat-mdc-elevation-specific mat-elevation-z8">
    <div class="mat-mdc-menu-content">
      @for (item of dadosAdicionais; track $index) {
        <div>
          <mat-checkbox
            class="slc-checkbox-brand mat-mdc-menu-item"
            [(ngModel)]="item.sel"
            (change)="onDadoAdicionalChanged(item)"
            >{{ item.descricao }}</mat-checkbox
          >
        </div>
      }
    </div>
  </div>
</ng-template>

<!-- Este mat-menu está aqui apenas para carregar as classes css utilizadas -->
<mat-menu #menu="matMenu"> </mat-menu>
